<template>
  <div class="d-flex flex-wrap flex-gap">
    <v-checkbox
      v-model="selected"
      hide-details="auto"
      label="Cấp 1"
      value="primary"
      class="mt-0"
      :disabled="!listAcademic['primary']"
    ></v-checkbox>
    <v-checkbox
      v-model="selected"
      hide-details="auto"
      label="Cấp 2"
      value="secondary"
      class="mt-0"
      :disabled="!listAcademic['secondary']"
    ></v-checkbox>
    <v-checkbox
      v-model="selected"
      hide-details="auto"
      label="Cấp 3"
      value="high"
      :disabled="!listAcademic['high']"
      class="mt-0"
    ></v-checkbox>
  </div>
</template>

<script>
import { AcademicLevel } from '@/plugins/api'
import { keyBy } from 'lodash'

export default {
  data: () => ({
    selected: [],
    academics: [],
    listAcademic: {}
  }),
  props: {
    defaults: {
      type: Array,
      default: () => []
    },
    isDefaultCheckAll: {
      type: Boolean,
      default: () => true
    }
  },
  async created() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.listAcademic = await AcademicLevel.fetch({ status: 'active' })
      this.listAcademic = keyBy(this.listAcademic, 'type')
      if (this.defaults && this.defaults.length) {
        this.selected = this.defaults.map(l => l.type)
      } else {
        this.academics = this.listAcademic
        if (this.isDefaultCheckAll) this.selected = ['primary', 'secondary', 'high']
        else this.selected = []
      }

      this.$emit('change', this.academics)
    }
  },

  watch: {
    selected(val) {
      this.academics = val.map(type => this.listAcademic[type])
      this.$emit('change', this.academics)
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-gap {
  gap: 16px;
}
</style>
